export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10728.396c52ac.jpg";